/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Tuda_Seltener_Als_Zweimal_Pro_Monat30Inputs */

const en__field_enum_tuda_seltener_als_zweimal_pro_monat30 = /** @type {(inputs: _Field_Enum_Tuda_Seltener_Als_Zweimal_Pro_Monat30Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`less then twice a month`)
};

const de__field_enum_tuda_seltener_als_zweimal_pro_monat30 = /** @type {(inputs: _Field_Enum_Tuda_Seltener_Als_Zweimal_Pro_Monat30Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`seltener als zwei mal im Monat`)
};

/**
* | output |
* | --- |
* | "less then twice a month" |
*
* @param {_Field_Enum_Tuda_Seltener_Als_Zweimal_Pro_Monat30Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_tuda_seltener_als_zweimal_pro_monat30 = /** @type {((inputs?: _Field_Enum_Tuda_Seltener_Als_Zweimal_Pro_Monat30Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Tuda_Seltener_Als_Zweimal_Pro_Monat30Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_tuda_seltener_als_zweimal_pro_monat30(inputs)
	return de__field_enum_tuda_seltener_als_zweimal_pro_monat30(inputs)
});
export { _field_enum_tuda_seltener_als_zweimal_pro_monat30 as "_field_enum_TUDA_SELTENER_ALS_ZWEIMAL_PRO_MONAT" }